<template>
  <f7-page name="sim-connectivity" ref="page" :page-content="false">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ $t('Connectivity') }}</f7-nav-title>
      <f7-nav-right>

      </f7-nav-right>
    </f7-navbar>

    <f7-toolbar tabbar top class="toolbar-font-size-12">
      <f7-link href="/sim/connectivity/hlr-info/" route-tab-id="tab-hlr-info" tab-link>{{ $t('HLRInfo') }}</f7-link>
      <f7-link href="/sim/connectivity/current-session/" route-tab-id="tab-current-session" tab-link>{{ $t('CurrentSession') }}</f7-link>
      <f7-link href="/sim/connectivity/sessions-data/" route-tab-id="tab-sessions-data" tab-link>{{ $t('SessionsData') }}</f7-link>
    </f7-toolbar>

    <f7-tabs :routable="true">
      <f7-tab id="tab-hlr-info" class="page-content"></f7-tab>
      <f7-tab id="tab-current-session" class="page-content"></f7-tab>
      <f7-tab id="tab-sessions-data" class="page-content"></f7-tab>
    </f7-tabs>

  </f7-page>
</template>

<script>
export default {
  name: "sim-connectivity",

  data(){
    return {

    }
  }
}
</script>

<style scoped>

</style>